// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"426":"640a13ae","607":"4728528e","751":"60293cc5","787":"c1112931"}[chunkId] + ".chunk.js";
};